import { RicosPluginToolbarNames } from 'ricos-types';
import { DEFAULTS } from './consts.js';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { Settings } from './settings/settings.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { IMAGE_TYPE } from './types.js';
import 'ricos-schema';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-plugin-commons';
import './toolbar/imagePluginService.js';
import 'lodash';
import './icons/InsertPluginIcon.js';
import 'react';
import 'wix-rich-content-toolbars-ui';
import './image-editor-modal/image-editor-modal.js';
import 'ricos-context';
import './imageStudio/image-editor-logic.js';
import './imageStudio/image-studio-opener-loader.js';
import './toolbar/ImageEditorButton.js';
import '@wix/design-system';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './settings/use-spoiler-plugin.js';
import 'ricos-content';
import 'ricos-schema/dist/statics/image.defaults.json';
import './tiptap/component.js';
import './viewer/get-image-click-action-config.js';
import './viewer/image.js';
import 'classnames';
import './image-viewer.rtlignore-0d751719.js';
import './style-inject.es-e7b07dd7.js';
import './icons/expand.js';
import './viewer/image-container.js';
import './viewer/use-custom-width-style.js';
import './viewer/use-fallback-width-style.js';
import './viewer/use-image-dimensions.js';
import './viewer/use-image-social-attributes.js';
import './tiptap/editor-image-caption.js';
import './InPluginInput.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginImage = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: IMAGE_TYPE,
    tiptapExtensions,
    toolbar: {
      names: [RicosPluginToolbarNames.IMAGE],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    __exports: {
      SettingsModal: Settings
    }
  };
};

export { pluginImage };
//# sourceMappingURL=editor.js.map
